<template>
  <div class="loan-upload">
    <div class="head">
      <div class="title" v-if="$route.query.userType">个人抵押贷款上传材料</div>
      <div class="title" v-else>农户贷上传材料</div>
      <div class="tool">
        <div @click="$router.go(-1)">上一步</div>
        <div @click="sumbit(2)">下一步</div>
      </div>
    </div>
    <div class="title">申请人相关资料</div>
    <div class="m50">
      <el-form class="form">
        <el-row class="mt20">
          <el-col v-for="(item) in fileList" :key="item.id">
            <div v-if="item.maxNumber == 1">
              <el-form-item
                :label="item.fileName"
                :class="{'must': item.isRequire}"
                label-width="390px"
                style="margin-bottom: 0;"
              >
                <DataUpload
                  style="display:inline-block; margin-left:50px;"
                  :fileFuther.sync="item"
                  :downFlag="downFlag"
                />
              </el-form-item>
            </div>
            <div v-else>
              <el-form-item
                :label="`${item.fileName}(可上传多份)`"
                :class="{'must': item.isRequire}"
                label-width="390px"
                style="margin-bottom: 0;"
              >
                <ListUpload
                  style="display: inline-block; margin-left:50px;"
                  :fileFuther.sync="item"
                  :downFlag="downFlag"
                />
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import DataUpload from "@/components/DataUpload/OneUpload.vue";
import ListUpload from "@/components/DataUpload/ListUpload.vue";
import { sessionStore } from "@/utils/data-management";
export default {
  components: {
    DataUpload,
    ListUpload
  },
  data() {
    return {
      fileList: [],
      downFlag: true,
      fileData: {} // 详情
    };
  },
  methods: {
    async init() {
      if (sessionStore.get("loanFile")) {
        sessionStore.remove("loanFile");
      }
      if (sessionStore.get('loanFileList')) {
        this.fileList = sessionStore.get('loanFileList')
        return
      }
      let params = {
        generatePosition: 6,
        role: "farmer",
        listingMode: 7
      };
      // 已上传文件
      await this.$api.apply.getLoanFiles({}).then(res => {
        if (res.code == 1000) {
          this.fileData = res.data || [];
        }
      });
      // 所需上传文件
      await this.$api.apply.getProcessFiles(params).then(res => {
        if (res.code == 1000) {
          // 详情
          let detail = {};
          this.fileData.forEach(item => {
            item.fileUrl = item.fileAddr;
            detail[item.fileType] = detail[item.fileType] || [];
            detail[item.fileType].push(item);
          });
          res.data.forEach(item => {
            item.fileList = detail[item.fileType] || [];
          });
          this.fileList = res.data;
        }
      });
    },
    // 校验
    checkFileAddr(list) {
      return (
        list &&
        list.every(item => {
          if (item.isRequire && item.fileList.length < 1) {
            this.$message.error(`请将《${item.fileName}》的相关资料上传完善`);
            return false;
          } else {
            return true;
          }
        })
      );
    },
    sumbit(index) {
      const check = this.checkFileAddr(this.fileList);
      if (check) {
        let data = [];
        this.fileList.map(item => {
          item.fileList.map(list => {
            data.push({
              fileType: list.fileType,
              fileName: list.fileName,
              fileAddr: list.fileUrl
            });
          });
        });
        sessionStore.set("loanFile", data);
        sessionStore.set('loanFileList', this.fileList)
        if(this.$route.query.userType){
          this.$router.push({ name: "personApplyLoan" });
        }else{
          this.$router.push({ name: "applyLoan" });
        }
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.loan-upload {
  background: #fff;
  padding: 0 35px 20px;
}
.head {
  height: 90px;
  margin-bottom: 37px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title {
    line-height: 20px;
    padding-left: 12px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #f65248;
    position: relative;
  }
  .title::before {
    content: "";
    width: 4px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 0;
    background: #f65248;
  }
  .tool {
    display: flex;
    div {
      width: 88px;
      line-height: 30px;
      margin-left: 20px;
      text-align: center;
      color: #fff;
      background-image: linear-gradient(-135deg, #55607b 0%, #394259 100%);
      border-radius: 2px;
      cursor: pointer;
    }
    div:last-child {
      width: 136px;
      background-image: linear-gradient(-135deg, #ff7067 0%, #ef5147 100%);
    }
  }
}
.title {
  line-height: 54px;
  padding-left: 52px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #394259;
  background: #f8f9fb;
}
.el-form {
  width: 100%;
  margin: 0;
  .el-form-item {
    .el-input,
    .el-select {
      width: 300px;
      /deep/ input {
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
        padding: 9px 10px;
      }
    }
    .el-textarea {
      /deep/ textarea {
        border-radius: 2px;
        border: 1px solid rgba(240, 240, 240, 1);
      }
    }
  }
  .must {
    /deep/ .el-form-item__label::before {
      content: "*";
      margin-right: 5px;
      color: #f65248;
    }
  }
  .itemError .el-form-item__label {
    color: #f65248;
  }
}
</style>